<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToSelect',
	componentName: 'ToSelect'
});
</script>
<template>
	<!-- 选择器主容器 -->
	<div :id="id" :key="langKey" ref="$el" v-tip="changed ? t('to.common.originalValue', getLabel(valueStore[0])) : ''" :flex="flex ? flex : null" class="to-select" :class="setClass" :style="setStyle" :tabindex="tabindex" @mousedown="layerMousedown" @focus="focus" @blur="blur" @keyup.enter="enter" @keyup.esc="closeLayer" @click="click">
		<div ref="trigger" class="to-select-el">
			<!-- 表单验证元素2（隐藏） -->
			<span v-if="verifiable && (rule || required || ToFormItem?.required)" v-show="false" :trim="trim" :req="validateRequired" class="to-validate" :desc="validateDesc" :rule="rule" :value="validateValue"></span>

			<!-- 前缀插槽 -->
			<span v-if="$slots.prefix" class="to-select-prefix">
				<slot name="prefix"></slot>
			</span>

			<!-- 前缀文本 -->
			<span v-if="prefix" class="to-select-prefix-text">
				<span>{{ prefix }}</span>
			</span>

			<!-- 选择器内容区域 -->
			<span ref="optionLayerTrigger" class="to-select-content">
				<!-- 前缀图标 -->
				<ToIcon v-if="icon" :value="icon" mode="none" class="to-select-icon"></ToIcon>

				<!-- 原生select模式 -->
				<template v-if="native">
					<span class="to-select-box">
						<select ref="selector" v-model="iValue">
							<option v-if="clearable" value="">{{ placeholder || t('to.common.placeholder.select') }}</option>
							<option v-for="(item, index) in options" :key="index" :value="item[iValueText]">
								{{ item[iLabelText] }}
							</option>
						</select>
					</span>
				</template>

				<!-- 自定义模拟选择器 -->
				<template v-else>
					<!-- 单选模式 -->
					<template v-if="!multiple">
						<!-- 单选显示值（非输入模式或手机端） -->
						<span v-if="(!inputable && !filterable && !setDataFn && !remoteMethod) || $phone" class="to-select-box">
							<template v-if="(selected as any)[iLabelText]">
								{{ (selected as any)[iLabelText] }}
								<template v-if="unit">{{ unit }}</template>
							</template>
							<template v-else>{{ placeholder || t('to.common.placeholder.select') }}</template>
						</span>
						<!-- 单选输入框区域 -->
						<span v-else class="to-select-input">
							<!-- 可输入模式 inputable = true filterable = false 的输入框 -->
							<to-input v-if="inputable && !filterable && !setDataFn && !remoteMethod" ref="input" v-model="inputValue" :disabled="disabled" :sp-chars="spChars" :tabindex="tabindex" :clearable="clearable" prevent-focus width="full" mode="none" :placeholder="placeholder || t('to.common.placeholder.select')" @focus="inputFocus" @keyup="inputInput" @blur="inputBlur"></to-input>
							<!-- 可过滤模式 filterable = true 或 远程搜索模式 remoteMethod 存在的输入框 -->
							<to-input v-if="filterable || remoteMethod" ref="filter" v-model="filterValue" :disabled="disabled" :focus-when-clear="focusWhenClear" :sp-chars="inputable ? spChars : false" :tabindex="tabindex" :clearable="clearable" prevent-focus width="full" mode="none" :placeholder="placeholder || t('to.common.placeholder.select')" @clear="filterClear" @focus="filterFocus" @keyup="filterInput" @blur="filterBlur"></to-input>
							<!-- 自定义数据设置模式的输入框 -->
							<to-input v-if="setDataFn" v-model="setDataInputValue" :disabled="disabled" :sp-chars="inputable ? spChars : false" :tabindex="tabindex" :clearable="clearable" prevent-focus width="full" mode="none" :placeholder="placeholder || t('to.common.placeholder.select')" @clear="filterClear" @focus="filterFocus" @keyup="filterInput" @blur="filterBlur"></to-input>
						</span>
					</template>

					<!-- 多选模式 -->
					<template v-else>
						<!-- 多选占位符（无选中项且非输入模式时显示） -->
						<span v-if="(selected as any[]).filter(item => !item.hide).length === 0 && !inputable && !filterable && !setDataFn && !remoteMethod" class="to-select-box">
							{{ placeholder || t('to.common.placeholder.select') }}
						</span>

						<!-- 全选状态显示文本 -->
						<span v-else-if="isAll && useAllText" class="to-select-box">{{ allText || t('to.select.input.allSelected') }}</span>

						<!-- 多选标签容器 -->
						<span v-else class="to-select-tag">
							<!-- 已选中项的标签显示 -->
							<template v-if="(selected as any[]).length > 0 && !(isAll && useAllText)">
								<template v-for="(item, index) in selected as any[]">
									<to-tag v-if="!item.hide" :key="index" class="to-select-item" :removable="removable && !disabled" @remove="removeTag(item)">
										{{ item[iLabelText] }}
									</to-tag>
								</template>
							</template>
							<!-- 多选输入框区域（非手机端或手机端无选中项时显示） -->
							<span v-if="!$phone || ($phone && selected.length === 0)" class="to-select-input">
								<!-- 多选可输入模式的输入框 -->
								<to-input v-if="inputable && !filterable && !remoteMethod" ref="input" v-model="multipleInputValue" :sp-chars="spChars" :disabled="$phone" prevent-focus mode="none" :placeholder="(selected as any[]).filter(item => !item.hide).length > 0 ? '' : placeholder || t('to.common.placeholder.select')" @focus="multipleInputFocus" @blur="multipleInputBlur"></to-input>
								<!-- 多选可过滤模式 filterable = true 或 远程搜索模式 remoteMethod 存在的输入框 -->
								<to-input v-if="filterable || remoteMethod" ref="filter" v-model="multipleFilterValue" :sp-chars="inputable ? spChars : false" :disabled="$phone" prevent-focus mode="none" :placeholder="(selected as any[]).filter(item => !item.hide).length > 0 ? '' : placeholder || t('to.common.placeholder.select')" @focus="multipleFilterFocus" @blur="multipleFilterBlur"></to-input>
								<!-- 多选自定义数据设置模式的输入框 -->
								<to-input v-if="setDataFn" ref="filter" v-model="setDataInputValue" :sp-chars="inputable ? spChars : false" prevent-focus mode="none" :placeholder="(selected as any[]).filter(item => !item.hide).length > 0 ? '' : placeholder || t('to.common.placeholder.select')" @focus="multipleFilterFocus" @blur="multipleFilterBlur"></to-input>
							</span>
						</span>
					</template>
				</template>

				<!-- 下拉箭头图标 -->
				<span class="to-select-arrow" :class="`type-${arrowType}`"></span>
			</span>

			<!-- 后缀文本 -->
			<span v-if="suffix" class="to-select-suffix-text">
				<span>{{ suffix }}</span>
			</span>

			<!-- 后缀插槽 -->
			<span v-if="$slots.suffix" class="to-select-suffix">
				<slot name="suffix"></slot>
			</span>

			<!-- 错误提示信息 -->
			<span v-if="errorTip" v-color="'danger'" class="to-box-tip">
				<template v-if="errorType === 'rule'">
					<template v-if="inputable">{{ t('to.input.inputError') }}</template>
					<template v-else>{{ t('to.select.selectError') }}</template>
					<ToIcon v-tip.danger="errorTip" value="help" color="danger" mode="toast"></ToIcon>
				</template>
				<template v-else>{{ t('to.select.required') }}</template>
			</span>
		</div>

		<!-- 下拉选项面板 -->
		<Teleport to="body">
			<div class="to-select" :class="setClass">
				<ToFloat ref="optionLayer" :style="{ transform: `scale(${currentScale})`, transformOrigin: 'left top' }" :global="false" class="to-select-option" :class="setOptionClass" :align="optionDisplay === 'popup' ? 'center' : optionAlign" :width="iOptionWidth" :slide="layerSlide" :position="layerPosition" @closed="layerClose" @mousedown="layerMousedown" @before-open="layerOpen">
					<!-- 数据加载状态 -->
					<ToPadding v-if="dataLoading" v-align="'center'" :value="2">
						<ToIcon value="loading"></ToIcon>
					</ToPadding>

					<!-- 选项内容区域 -->
					<template v-else>
						<!-- 选项数据插槽 -->
						<slot :data="options">
							<!-- 弹窗模式 -->
							<to-grid v-if="optionDisplay === 'popup' || ((inputable || filterable) && $phone)" style="width: 100%" type="v">
								<!-- 弹窗头部区域 -->
								<to-grid-item side width="full">
									<!-- 弹窗标题栏 -->
									<ToPadding value="1">
										<to-header level="0" :title="validateDesc ? t('to.select.float.title', validateDesc) : t('to.select.float.titlePlaceholder', validateDesc)" @back="closeLayer()">
											<to-button icon="close" mode="none" color="primary" @click="(clear(), closeLayer())">
												{{ t('to.common.clear') }}
											</to-button>
										</to-header>
									</ToPadding>

									<!-- 弹窗内的搜索/输入区域 -->
									<ToPadding v-if="filterable || inputable || remoteMethod" position="side" value="1">
										<!-- 多选模式的弹窗输入区域 -->
										<template v-if="multiple">
											<!-- 多选可输入模式 -->
											<template v-if="inputable && !filterable && !remoteMethod">
												<span class="to-select to-select-arrow-none" style="width: 100%">
													<span class="to-select-content">
														<span class="to-select-tag">
															<!-- 弹窗内已选标签显示 -->
															<template v-if="(selected as any[]).length > 0 && !(isAll && useAllText)">
																<template v-for="(item, index) in selected as any[]">
																	<to-tag v-if="!item.hide" :key="index" color="fg" mode="plain" :removable="removable && !disabled" @remove="removeTag(item)">
																		{{ item[iLabelText] }}
																	</to-tag>
																</template>
															</template>
															<!-- 弹窗内过滤输入框 -->
															<to-input v-if="filterable || remoteMethod" ref="popupFilter" v-model="multipleFilterValue" :sp-chars="spChars" prevent-focus mode="none" :placeholder="(selected as any[]).filter(item => !item.hide).length > 0 ? '' : placeholder || t('to.common.placeholder.select')">
																<to-button icon="ok" mode="none" color="primary" @click="enter"></to-button>
															</to-input>
															<!-- 弹窗内输入框 -->
															<to-input v-else ref="popupInput" v-model="multipleInputValue" prevent-focus mode="none" :placeholder="selected.filter(item => !item.hide).length > 0 ? '' : placeholder || t('to.common.placeholder.select')">
																<to-button icon="ok" mode="none" color="primary" @click="enter"></to-button>
															</to-input>
														</span>
													</span>
												</span>
											</template>
											<!-- 多选仅过滤模式 -->
											<to-input v-else ref="popupFilter" v-model="multipleFilterValue" :sp-chars="false" width="full" prevent-focus :placeholder="(selected as any[]).filter(item => !item.hide).length > 0 ? '' : placeholder || t('to.common.placeholder.select')"></to-input>
										</template>
										<!-- 单选模式的弹窗输入区域 -->
										<template v-else>
											<!-- 单选可输入模式 -->
											<to-input v-if="inputable && !filterable && !remoteMethod" ref="popupInput" v-model="inputValue" :sp-chars="spChars" prevent-focus width="full" :placeholder="placeholder || t('to.common.placeholder.select')"></to-input>
											<!-- 单选过滤模式 或 远程搜索模式 -->
											<to-input v-else-if="filterable || remoteMethod" ref="popupFilter" v-model="filterValue" :sp-chars="false" prevent-focus width="full" :placeholder="t('to.select.filter')" @clear="filterClear"></to-input>
										</template>
									</ToPadding>
								</to-grid-item>

								<!-- 弹窗选项内容区域 -->
								<to-grid-item width="full">
									<!-- 无数据提示 -->
									<ToPadding v-if="nodata" v-color="'info'" :value="2">
										{{ nodataText || t('to.select.noData') }}
									</ToPadding>

									<!-- 无匹配项提示 -->
									<ToPadding v-else-if="nomatch" v-color="'info'" :value="2">
										{{ nomatchText || t('to.select.noMatch') }}
									</ToPadding>

									<!-- 选项列表滚动区域-->
									<to-scroll v-if="!nodata && !nomatch">
										<ToPadding :value="0.5">
											<!-- 弹窗内多选选项 -->
											<template v-if="multiple">
												<!-- 全选/反选按钮 -->
												<ToPadding :value="0.5">
													<to-button @click="selectAll">{{ t('to.common.selectAll') }}</to-button>
													<to-button @click="inverse">{{ t('to.common.inverse') }}</to-button>
												</ToPadding>

												<!-- 多选选项网格 -->
												<to-grid :col="optionCol">
													<to-grid-item v-for="item in options" v-show="multipleFilter(item)" :key="item[iValueText]" v-dis="!!item.disabled" width="full">
														<to-checkbox
															:wrap="optionWrap"
															:title="item[iLabelText]"
															width="full"
															:label="item[iLabelText]"
															:disabled="!!item.disabled"
															:value="Boolean((selected as any[]).find(el => el[iValueText] === item[iValueText]))"
															@change="
																value => {
																	return multipleItemChange(value, item)
																}
															"
														></to-checkbox>
													</to-grid-item>
												</to-grid>
											</template>

											<!-- 弹窗内单选选项 -->
											<template v-else>
												<!-- 单选选项网格 -->
												<to-grid :col="optionCol">
													<div v-for="item in options" v-show="filterByValue(item)" :key="item[iValueText]" v-dis="!!item.disabled" :class="{ 'is-on': (selected as any)[iValueText] === item[iValueText] }" @click.stop="itemChange(item)">
														<template v-if="item[iLabelText]">{{ item[iLabelText] }}</template>
														<template v-else>{{ placeholder || t('to.common.placeholder.select') }}</template>
													</div>
												</to-grid>
											</template>
										</ToPadding>
									</to-scroll>
								</to-grid-item>
								<to-grid-item side width="full">
									<to-grid>
										<to-button v-size="'l'" color="primary" mode="line" @click="(phoneCloseLayer(), (iValue = ''))">
											{{ t('to.common.clear') }}
										</to-button>
										<to-button v-size="'l'" mode="fill" color="primary" @click="phoneCloseLayer()">
											{{ t('to.common.confirm') }}
										</to-button>
									</to-grid>
								</to-grid-item>
							</to-grid>

							<!-- 普通模式 -->
							<template v-else>
								<!-- 无数据提示 -->
								<div v-if="nodata" class="to-select-option-tip">
									{{ nodataText || t('to.select.noData') }}
								</div>

								<!-- 无匹配提示 -->
								<div v-else-if="nomatch" class="to-select-option-tip">
									{{ nomatchText || t('to.select.noMatch') }}
								</div>

								<!-- 普通下拉选项滚动区域-->
								<to-scroll v-if="!nodata && !nomatch">
									<!-- 多选选项 -->
									<template v-if="multiple">
										<!-- 全选/反选按钮 -->
										<div class="to-select-option-fn">
											<to-button class="to-select-option-button value-all" @click="selectAll">
												{{ t('to.common.selectAll') }}
											</to-button>
											<to-button class="to-select-option-button value-inverse" @click="inverse">
												{{ t('to.common.inverse') }}
											</to-button>
										</div>

										<!-- 多选选项网格 -->
										<to-grid class="to-select-list is-multiple" :col="optionCol">
											<to-checkbox
												v-for="item in options"
												v-show="multipleFilter(item)"
												:key="item[iValueText]"
												v-dis="!!item.disabled"
												class="to-select-check"
												:wrap="optionWrap"
												:title="item[iLabelText]"
												width="full"
												:label="item[iLabelText]"
												:disabled="!!item.disabled"
												:value="Boolean(selected.find(el => el[iValueText] === item[iValueText]))"
												@change="
													value => {
														return multipleItemChange(value, item)
													}
												"
											></to-checkbox>
										</to-grid>
									</template>

									<!-- 单选选项 -->
									<template v-else>
										<!-- 单选选项网格 -->
										<to-grid :col="optionCol" class="to-select-list">
											<div v-for="item in options" v-show="filterByValue(item)" :key="item[iValueText]" v-dis="!!item.disabled" class="to-select-option-item" :class="{ 'is-on': (selected as any)[iValueText] === item[iValueText] }" @click.stop="itemChange(item)">
												<span v-if="item[iLabelText]" class="to-select-option-item-text">{{ item[iLabelText] }}</span>
												<span v-else class="to-select-option-item-text">{{ placeholder || t('to.common.placeholder.select') }}</span>
											</div>
										</to-grid>
									</template>
								</to-scroll>
							</template>
						</slot>
					</template>
				</ToFloat>
			</div>
		</Teleport>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, watch, inject, nextTick, onMounted, onUnmounted } from 'vue'
import { t, langKey } from '@touchvue/locale'
import { selectProps, SelectValueType, SelectOptionsData } from './select'
import { useSetSelectClassStyle, useSelectOptionData } from './hooks'
import { useDevice } from '@touchvue/hooks'
// import { isString } from '@touchvue/utils'
import { ToIcon, ToPadding, ToCheckbox, ToGrid, ToGridItem, ToScroll, ToButton, ToFloat, ToInput, ToTag, ToHeader } from '@touchvue/components'
import { vColor, vDis } from '@touchvue/directives'

/**
 * 【组件初始化】
 * created → 初始化内部变量 → setOptions() → 设置选项数据 → setValue() → 设置选中状态
 * 【点击选项：单选】
 * 点击选项 → @click.stop="itemChange(item)" → itemChange() → change() → emit('update:modelValue', value)
 * 【点击选项：多选】
 * 点击选项 → @change="multipleItemChange(value, item)" → multipleItemChange() → change() → emit('update:modelValue', value)
 * 【异步数据加载调用链】
 * getData() → 配置API参数 → 缓存检查 → HTTP请求 → 数据解析 → setValue() → 触发事件
 * 【modelValue变化监听】
 * watch(props.modelValue) → iValue.value更新 → setValue() → 重新设置选中状态
 * 【内部值iValue变化监听】
 * watch(iValue) → setSelected() → 触发change和update:modelValue事件 → valueChange()
 * 【选项过滤】
 * 输入框输入 → filterValue/multipleFilterValue更新 → 模板中v-show="filterByValue(item)" → 动态显示/隐藏选项
 * 【多选批量操作】
 * 全选按钮点击 → selectAll() → allChange() → change() → emit('update:modelValue')
 * 反选按钮点击 → inverse() → reverseChange() → change() → emit('update:modelValue')
 */

// 当前计算出的缩放比例
const currentScale = ref(1)

// 计算缩放比例的核心方法
const calcScale = () => {
	if (!$el.value) return

	// 1. 获取布局宽度（不受 transform 影响）
	const layoutWidth = $el.value.offsetWidth
	if (layoutWidth === 0) return // 避免除以 0

	// 2. 获取视觉宽度（被外层 transform 缩放后的实际宽度）
	const visualWidth = $el.value.getBoundingClientRect().width

	// 3. 计算缩放比例（四舍五入保留 4 位小数，避免精度问题）
	currentScale.value = Number((visualWidth / layoutWidth).toFixed(4))
}

// 组件挂载后初始化缩放比例，并开启监听
onMounted(() => {
	// 初始化计算
	calcScale()

	// 监听窗口 resize（可能导致外层元素缩放/布局变化）
	window.addEventListener('resize', calcScale)

	// 组件卸载时停止监听
	onUnmounted(() => {
		window.removeEventListener('resize', calcScale)
	})
})

// 定义组件名称


// 定义props
const props = defineProps(selectProps)

// 定义emits
const emit = defineEmits<{
	change: [value: SelectValueType, option: any]
	select: [value: string | number]
	'update:modelValue': [value: SelectValueType]
	'option-loaded': [options: any[]]
}>()
// inject
const ToForm = inject('ToForm', null) as any
const ToFormItem = inject('ToFormItem', null) as any
const $TouchUI = inject('$TouchUI', {
	colors: ['primary', 'success', 'warning', 'danger', 'info', 'default', 'dark']
}) as any

const { isPhone } = useDevice()
const $phone = isPhone.value

/* ================================ 核心数据状态 ================================ */
// 组件核心值状态
/**
 * 当前值
 */
const iValue = ref<SelectValueType>(props.modelValue)
const valueStore = ref([])
const inited = ref(false)

/* ================================ UI交互状态 ================================= */
// 焦点状态
const focused = ref(false)
/** mousedown 时是否已处于聚焦（先于本次点击触发的 focus，用于区分首次点击与框内再点） */
const blurByLayer = ref(false)

// 弹层状态
const layerSlide = ref(false)
const layerPosition = ref('')

// 组件状态
const disabled = ref(props.disabled)
const isChanging = ref(false)

/* ================================ 输入状态 ================================ */
// 输入框值
const filterValue = ref('')
const inputValue = ref('')
const multipleInputValue = ref('')
const multipleFilterValue = ref('')
const setDataInputValue = ref('')

/* ================================ 加载状态 ================================ */
// 数据加载状态
const dataLoading = ref(false)

/* ================================ 验证状态 ================================ */
// 错误提示状态
const errorTip = ref('')
const errorType = ref('rule')

/* ================================ 配置状态 ================================ */
// API配置
const iApiHeaders = ref({})
const iResPath = ref(props.resPath)
const iSuccessCode = ref(props.successCode)
const iApiParam = ref(props.apiParam)
const iApiLabel = ref(props.apiLabel)
const iErrorPath = ref(props.errorPath)

// 显示配置
const iOptionWidth = ref(props.optionWidth)
const iLabelText = ref(props.labelText)
const iValueText = ref(props.valueText)

/* ================================ DOM引用 ================================ */
// DOM元素引用
const $el = ref(null)
const selector = ref(null)
const input = ref(null)
const filter = ref(null)
const optionLayer = ref(null)
const popupFilter = ref(null)
const popupInput = ref(null)
const trigger = ref(null)

// const inputing = ref(false) // 未使用，已注释

/* ================================ 选项数据状态 ================================ */
// 选项数据
const options = ref<SelectOptionsData[]>([])
const anotherOptions = ref<SelectOptionsData[]>([])

// 选中状态
const { selected } = useSelectOptionData({
	props
})

const filterByValue = (item: SelectOptionsData) => {
	if (!props.filterable && !props.remoteMethod) return true
	if (props.remoteMethod) return true
	const value = filterValue.value
	if (value === '') return true
	return item[iLabelText.value].includes(value)
}

const multipleFilter = (item: SelectOptionsData) => {
	if (!props.filterable && !props.remoteMethod) return true
	if (props.remoteMethod) return true
	const value = multipleFilterValue.value
	if (value === '') return true
	return item[iLabelText.value].includes(value)
}

const nomatch = computed(() => {
	let nomatch = true
	let value = props.multiple ? multipleFilterValue.value : filterValue.value
	if (value === '') {
		nomatch = false
	} else if (!props.remoteMethod) {
		// !props.remote 时，本地过滤
		// 本地过滤时判断是否有匹配项
		if (options.value.findIndex(option => option[iLabelText.value].includes(value)) > -1) {
			nomatch = false
		}
	} else {
		// 远程搜索时，如果有选项则认为有匹配项
		if (options.value.length > 0) {
			nomatch = false
		}
	}
	return nomatch
})

const nodata = computed(() => {
	return options.value.length === 0
})

// 选项数据处理方法
const setOptions = () => {
	// 同步选项（含空数组，用于 data 从有值变为空时清空下拉选项）
	if (props.data) {
		setData()
	}

	// 异步选项
	if (props.api) {
		getData()
	}
}

const setData = () => {
	if (props.data) {
		if (typeof props.data === 'string') {
			let arr = []
			for (let i = 0; i < props.data.split(',').length; i++) {
				const el = props.data.split(',')[i]
				let obj = {}
				obj[iLabelText.value] = obj[iValueText.value] = el
				arr.push(obj)
			}
			if ($phone && (props.filterable || props.remoteMethod)) {
				options.value = arr.slice(0, 100)
				anotherOptions.value = arr.slice(100)
			} else {
				options.value = arr
			}
		} else {
			if ($phone && (props.filterable || props.remoteMethod)) {
				options.value = props.data.slice(0, 100)
				anotherOptions.value = props.data.slice(100)
			} else {
				options.value = [...props.data]
			}
			if (typeof props.setLabelFn === 'function') {
				options.value.forEach(item => {
					item.label = props.setLabelFn(item)
				})
			}
		}

		setValue()
		setPlaceholder()

		emit('option-loaded', options.value)
	}
}

const getData = () => {
	if (props.api) {
		// 通过配置自动设置 labelText 与 valueText
		if ($TouchUI.staticDataApiConfig?.labelText && props.labelText === 'label') {
			iLabelText.value = $TouchUI.staticDataApiConfig.labelText
		}
		if ($TouchUI.staticDataApiConfig?.valueText && props.valueText === 'value') {
			iValueText.value = $TouchUI.staticDataApiConfig.valueText
		}
		if ($TouchUI.staticDataApiConfig?.resPath && !props.resPath) {
			iResPath.value = $TouchUI.staticDataApiConfig.resPath
		}
		if ($TouchUI.staticDataApiConfig?.apiParam && !props.apiParam) {
			iApiParam.value = $TouchUI.staticDataApiConfig.apiParam
		}
		if ($TouchUI.staticDataApiConfig?.apiHeaders && !props.apiHeaders) {
			iApiHeaders.value = $TouchUI.staticDataApiConfig.apiHeaders
		}
		if ($TouchUI.staticDataApiConfig?.apiLabel && !props.apiLabel) {
			iApiLabel.value = $TouchUI.staticDataApiConfig.apiLabel
		}
		if ($TouchUI.staticDataApiConfig?.errorPath && !props.errorPath) {
			iErrorPath.value = $TouchUI.staticDataApiConfig.errorPath
		}
		if ($TouchUI.staticDataApiConfig?.successCode && !props.successCode) {
			iSuccessCode.value = $TouchUI.staticDataApiConfig.successCode
		}

		// 从缓存中取数据，如果没有则异步获取
		if (sessionStorage.getItem('static.' + props.api)) {
			options.value = JSON.parse(sessionStorage.getItem('static.' + props.api))

			if ($phone && (props.filterable || props.remoteMethod)) {
				anotherOptions.value = options.value.slice(100)
				options.value = options.value.slice(0, 100)
			}

			setValue()
			setPlaceholder()
			emit('option-loaded', options.value)
		} else {
			dataLoading.value = true

			let action = ''
			let param = { ...iApiParam.value }

			if (iApiLabel.value && props.api) {
				Object.assign(param, { [iApiLabel.value]: props.api })
			}

			if (props.api.indexOf('http') > -1) {
				action = props.api
			} else {
				if ($TouchUI.staticDataApiConfig?.action && $TouchUI.staticDataApiConfig.action.indexOf('=') > -1 && $TouchUI.staticDataApiConfig.action.indexOf('?') > -1) {
					// 兼容 GET 格式的 POST 请求
					action = $TouchUI.staticDataApiConfig.action + props.api
				} else {
					action = $TouchUI.staticDataApiConfig?.action || props.api
				}
			}

			const requestOptions = {
				data: param,
				action,
				headers: Object.assign({}, iApiHeaders.value),
				onSuccess: res => {
					dataLoading.value = false

					if (typeof res === 'string') {
						res = JSON.parse(res)
					}

					// 直接返回一个 select 所需要的 data 对象时，不需要任何解析
					// 如：[{name:'张三', id:0},{name:'李四', id:1}]
					if (Array.isArray(res)) {
						options.value = res
						sessionStorage.setItem('static.' + props.api, JSON.stringify(res))

						if ($phone && (props.filterable || props.remoteMethod)) {
							anotherOptions.value = res.slice(100)
							options.value = res.slice(0, 100)
						}

						setValue()
						setPlaceholder()
						emit('option-loaded', options.value)
					} else if (res.code === iSuccessCode.value) {
						let data = res
						if (iResPath.value) {
							let resPath = iResPath.value.split('/')
							resPath.forEach(el => {
								data = data[el]
							})
						}
						options.value = data
						sessionStorage.setItem('static.' + props.api, JSON.stringify(data))

						if ($phone && (props.filterable || props.remoteMethod)) {
							anotherOptions.value = data.slice(100)
							options.value = data.slice(0, 100)
						}

						setValue()
						setPlaceholder()
						emit('option-loaded', options.value)
					} else {
						options.value = []
						console.error(t('to.select.tip.error.res', `select api(${props.api})`))
					}
				},
				onError: () => {
					dataLoading.value = false
					console.error(t('to.select.tip.error.api', `select api(${props.api}) `))
				}
			}

			const req = props.httpRequest(requestOptions)
			if (req && req.then) {
				req.then(requestOptions.onSuccess, requestOptions.onError)
			}
		}
	}
}

/**
 * 选项插入空选项“请选择”
 */
const setPlaceholder = () => {
	if (props.native) {
		return
	}
	if (!props.multiple && props.clearable && !props.inputable && !props.setDataFn && !props.filterable && !props.remoteMethod && (!props.optionDisplay || props.optionDisplay === 'float')) {
		options.value.unshift({
			[iLabelText.value]: '',
			[iValueText.value]: ''
		})
	}
}

const setValue = () => {
	if (props.multiple) {
		selected.value = []
		if (iValue.value) {
			const arr = Array.isArray(iValue.value) ? iValue.value : iValue.value.toString().split(props.splitSymbol || ',')
			arr.forEach(item => {
				if (item && item.toString().trim()) {
					let option = options.value.find(option => String(option[iValueText.value]) === String(item))
					if (option) {
						selected.value.push(option)
					} else if (props.inputable) {
						// 当输入一个不存在的值的时候，如果可自定义则显示，否则不显示
						selected.value.push({
							[iLabelText.value]: item,
							[iValueText.value]: item,
							hide: false
						})
					}
				}
			})
		}
	} else {
		let option = options.value.find(option => String(option[iValueText.value]) === String(iValue.value))

		if (option) {
			selected.value = option
		} else {
			if (iValue.value && props.inputable) {
				selected.value = {
					[iLabelText.value]: iValue.value,
					[iValueText.value]: iValue.value
				}
			} else {
				selected.value = {
					[iLabelText.value]: iValue.value,
					[iValueText.value]: iValue.value
				}
			}
		}
	}
	inited.value = true
	// filterable / remoteMethod 单选展示依赖 filterValue，setValue 后需同步（watch(iValue) 无 immediate）
	// if (!props.multiple && !props.inputable && (props.filterable || props.remoteMethod)) {
	// 	// 如果 filterValue 已有值（用户在输入过滤条件），则保留，不覆盖
	// 	if (!filterValue.value && iValue.value) {
	// 		const option = options.value.find(option => String(option[iValueText.value]) === String(iValue.value))
	// 		filterValue.value = option?.[iLabelText.value] ?? ''
	// 	}else{
	// 		filterValue.value = ''
	// 	}
	// }
}

// 选项变更处理方法
const itemChange = option => {
	if (option.disabled) {
		return
	}
	if (props.multiple) {
		multipleItemChange(true, option)
	} else {
		change(option[iValueText.value], option)
		closeLayer()
	}
	nextTick(() => {
		emit('select', option)
	})
}

// 选择全部
const selectAll = () => {
	allChange()
}

// 反选
const inverse = () => {
	reverseChange()
}

/**
 * 多选选项变更处理方法
 * @param value 选中状态
 * @param item 选项
 */
const multipleItemChange = (value: boolean, item: SelectOptionsData) => {
	if (item && item.disabled) return

	let arr = iValue.value ? iValue.value.toString().split(props.splitSymbol || ',') : []
	let selectedOptions = [...selected.value]
	if (value) {
		if (arr.indexOf(item[iValueText.value]) === -1) {
			arr.push(item[iValueText.value])
			selectedOptions.push(item)
		} else {
			arr = removeItem(arr, item[iValueText.value])
			selectedOptions = selectedOptions.filter(option => option[iValueText.value] !== value)
		}
	} else {
		arr = removeItem(arr, item[iValueText.value])
		selectedOptions = selectedOptions.filter(option => option[iValueText.value] !== value)
	}
	change(arr.join(props.splitSymbol || ','), selectedOptions)

	// 重置 input
	nextTick(() => {
		multipleFilterValue.value = ''
		filter.value.focus()
	})
}

const removeTag = (item: { [x: string]: any }) => {
	if (props.disabled || disabled.value) return

	let arr = iValue.value.toString().split(props.splitSymbol || ',')
	arr = removeItem(arr, item[iValueText.value])
	let selectedOptions = []
	selected.value.map(selectedItem => {
		if (selectedItem[iValueText.value] !== item[iValueText.value]) {
			selectedOptions.push(selectedItem)
		}
	})
	change(arr.join(props.splitSymbol || ','), selectedOptions)
}

// 工具方法
const removeItem = (arr, value) => {
	if (typeof arr === 'string') {
		arr = arr.split(',')
	}
	let index = arr.indexOf(value)
	if (index > -1) {
		arr.splice(index, 1)
	}
	return arr
}

// 选项处理相关的 watch 监听器
watch(
	() => props.data,
	() => {
		setOptions()
	}
)

watch(
	() => props.api,
	() => {
		setOptions()
	}
)

// 初始化layerSlide设置
const initLayerSlide = () => {
	if ($phone) {
		layerSlide.value = true
		layerPosition.value = 'bottom'
	}
	if (props.optionDisplay === 'popup' || ($phone && (props.filterable || props.inputable || props.remoteMethod))) {
		layerSlide.value = true
		layerPosition.value = 'right'
		if (!props.optionWidth) {
			iOptionWidth.value = '100%'
		}
	}
}

const onCreated = () => {
	// 初始化内部变量
	iLabelText.value = props.labelText
	iValueText.value = props.valueText
	iResPath.value = props.resPath
	iSuccessCode.value = props.successCode
	iApiParam.value = props.apiParam
	iApiHeaders.value = props.apiHeaders
	iApiLabel.value = props.apiLabel
	iErrorPath.value = props.errorPath
	iOptionWidth.value = props.optionWidth

	// 设置选项数据
	setOptions()

	// 初始化弹层设置
	initLayerSlide()
}

onCreated()

watch(
	() => props.apiParam,
	() => {
		iApiParam.value = props.apiParam
		if (props.api) {
			getData()
		}
	},
	{ deep: true }
)

watch(
	() => props.labelText,
	newVal => {
		iLabelText.value = newVal
		setValue()
	}
)

watch(
	() => props.valueText,
	newVal => {
		iValueText.value = newVal
		setValue()
	}
)

/* ================================ 计算属性 ================================ */
// 选项相关计算属性
const isAll = computed(() => {
	let arr = []
	options.value.map(item => {
		// 排除空的placeholder选项
		if (item[iValueText.value] !== '') {
			arr.push(item[iValueText.value])
		}
	})
	if (arr.sort().toString() === iValue.value.toString().split(',').sort().toString()) {
		return true
	} else {
		return false
	}
})

// 状态相关计算属性
const changed = computed(() => {
	if ((props.comparable || (ToForm && ToForm?.comparable)) && valueStore.value.length > 0 && iValue.value !== valueStore.value[0]) {
		return true
	} else {
		return false
	}
})

// 验证相关计算属性
const validateRequired = computed(() => {
	if (props.required) {
		return 'true'
	} else if (ToFormItem && ToFormItem.required) {
		return 'true'
	} else {
		return 'false'
	}
})

const validateDesc = computed(() => {
	if (props.desc) {
		return props.desc
	} else if (ToFormItem && ToFormItem.label) {
		return ToFormItem.label
	} else {
		return ''
	}
})

const validateValue = computed(() => {
	if (props.multiple) {
		if (selected.value.length > 0) {
			return 'true'
		} else {
			return ''
		}
	} else {
		return selected.value[iValueText.value]
	}
})

/* ================================ 样式处理 ================================ */
const { setClass, setStyle } = useSetSelectClassStyle({
	props,
	disabled,
	selected,
	iValueText,
	errorTip,
	changed,
	ToForm
})

const setOptionClass = computed(() => {
	let arr: string[] = []
	if (props.mode) {
		for (let i = 0; i < props.mode.split(' ').length; i++) {
			arr.push(`mode-${props.mode.split(' ')[i]}`)
		}
	}
	return arr
})

/* ================================ 事件处理函数 ================================ */
// 值变更事件
const change = (value, option) => {
	if (props.beforeChange) {
		let result = props.beforeChange(value, option)
		if (result === false) {
			return
		}
	}
	isChanging.value = true
	iValue.value = value
	setValue()
	emit('change', value, option)
	emit('update:modelValue', value)
	nextTick(() => {
		isChanging.value = false
	})
}

// 选项面板控制
const optionLayerTrigger = ref(null)

/**
 * 打开选项面板
 */
const openOptionLayer = () => {
	const el = props.optionDisplay == 'popup' ? null : trigger.value
	optionLayer.value.toggle(el)
}

const click = () => {
	if (!props.native && !(props.disabled || disabled.value)) {
		toggleLayer()
	}
}

const phoneCloseLayer = () => {
	optionLayer.value.close()
	if ((props.filterable || props.remoteMethod) && $phone) {
		options.value = options.value.slice(0, 100)
	}
}

// 弹层交互事件
const layerMousedown = () => {
	blurByLayer.value = true
}

// 焦点事件处理
const focus = () => {
	errorTip.value = ''
	focused.value = true
	// layerSlide.value = true;
}

const blur = () => {
	if (!blurByLayer.value) {
		focused.value = false
		layerSlide.value = false
		layerClose()
	}
	blurByLayer.value = false
}

const inputBlur = () => {
	if (!blurByLayer.value) {
		focused.value = false
		layerSlide.value = false
		layerClose()
	}
	blurByLayer.value = false
}

const inputFocus = () => {
	focused.value = true
	// layerSlide.value = true;
}

const filterBlur = () => {
	if (!blurByLayer.value) {
		focused.value = false
		layerSlide.value = false
		layerClose()
	}
	blurByLayer.value = false
}

const filterFocus = () => {
	focused.value = true
	// layerSlide.value = true;
}

const multipleInputBlur = () => {
	if (!blurByLayer.value) {
		focused.value = false
		layerSlide.value = false
		layerClose()
	}
	blurByLayer.value = true
}

const multipleInputFocus = () => {
	focused.value = true
}

const multipleFilterBlur = () => {
	if (!blurByLayer.value) {
		focused.value = false
		layerSlide.value = false
		layerClose()
	}
	blurByLayer.value = true
}

const multipleFilterFocus = () => {
	focused.value = true
}

// 输入事件处理
const inputInput = (e: { keyCode: number }) => {
	if (e.keyCode === 13) {
		if (props.setDataFn) {
			props.setDataFn(setDataInputValue.value, setDataLoading)
		}
	}
	// layerSlide.value = true;
}

let remoteSearchTimer = null

const remoteSearch = (keyword: string) => {
	if (props.remoteMethod) {
		props.remoteMethod(keyword)
	}
}

const filterInput = () => {
	if (props.remoteMethod) {
		const keyword = props.multiple ? multipleFilterValue.value : filterValue.value
		clearTimeout(remoteSearchTimer)
		remoteSearchTimer = setTimeout(() => {
			remoteSearch(keyword)
		}, 300)
	}
}

const filterClear = () => {
	iValue.value = ''
}

const setDataLoading = loading => {
	dataLoading.value = loading
}

// 键盘事件处理
const enter = () => {
	if (!(props.multiple && props.inputable)) {
		toggleLayer()
	} else {
		let value = props.filterable || props.remoteMethod ? multipleFilterValue.value : multipleInputValue.value
		if (selected.value.find(item => item[iLabelText.value] === value) || selected.value.find(item => item[iValueText.value] === value)) {
			errorTip.value = t('to.select.tip.error.repetition')
			errorType.value = 'rule'
			return
		}
		if (!value.trim()) {
			return
		}
		const newOption = {
			[iLabelText.value]: value,
			[iValueText.value]: value
		}
		if (props.beforeChange) {
			const fn = props.beforeChange(newOption)
			if (fn && fn.then) {
				fn.then(() => {
					selected.value.push(newOption)
				}).catch(() => {})
			} else {
				if (fn) {
					selected.value.push(newOption)
				}
			}
		} else {
			selected.value.push(newOption)
		}
		if (props.filterable || props.remoteMethod) {
			multipleFilterValue.value = ''
		} else {
			multipleInputValue.value = ''
		}
		if ($phone) {
			if (props.filterable || props.remoteMethod) {
				setTimeout(() => {
					popupFilter.value?.focus()
				}, 500)
			} else {
				setTimeout(() => {
					popupInput.value?.focus()
				}, 500)
			}
		}
	}
}

// 清除操作
const clear = () => {
	clearChange()
}

const clearChange = () => {
	if (props.multiple) {
		change('', [])
	} else {
		change('', null)
	}
	if (props.focusWhenClear && (props.filterable || props.remoteMethod)) {
		layerSlide.value = true
	}
}

// 批量选择操作
const allChange = () => {
	let arr = []
	let selectedOptions = []
	options.value.forEach(item => {
		// 排除空的placeholder选项和禁用项
		if (item[iValueText.value] !== '' && !item.disabled) {
			arr.push(item[iValueText.value])
			selectedOptions.push(item)
		}
	})
	change(arr.join(props.splitSymbol || ','), selectedOptions)
}

const reverseChange = () => {
	let arr = []
	let selectedOptions = []
	let selectedArr = iValue.value ? iValue.value.toString().split(props.splitSymbol || ',') : []
	options.value.forEach(item => {
		// 排除空的placeholder选项和禁用项，选择当前未选中的项
		if (item[iValueText.value] !== '' && !item.disabled && selectedArr.indexOf(item[iValueText.value].toString()) === -1) {
			arr.push(item[iValueText.value])
			selectedOptions.push(item)
		}
	})
	change(arr.join(props.splitSymbol || ','), selectedOptions)
}

/* ================================ 监听器 ================================ */
// selected监听器（从vue2迁移）
watch(
	selected,
	val => {
		if (props.multiple) {
			let arr = []
			val.map(item => {
				arr.push(item[iValueText.value])
			})
			if (inited.value) {
				iValue.value = arr.join(props.splitSymbol || ',')
			}
		} else {
			if (inited.value) {
				isChanging.value = true // 避免同时给 inputable 的 input 设置 inputValue 的时候触发 change 事件
				iValue.value = String(val[iValueText.value] || '')
				setTimeout(() => {
					isChanging.value = false
				}, 100)
			}
		}

		if (!inited.value) {
			if (Array.isArray(props.modelValue)) {
				iValue.value = props.modelValue.join(',')
			} else {
				iValue.value = props.modelValue
			}
			nextTick(() => {
				inited.value = true
			})
		}
	},
	{ deep: true }
)

// 输入值监听
watch(inputValue, () => {
	if (!isChanging.value) {
		iValue.value = inputValue.value
	}
})

watch(filterValue, val => {
	if (props.inputable) {
		nextTick(() => {
			iValue.value = val
		})
	}
})

watch(setDataInputValue, val => {
	if (props.setDataFn) {
		props.setDataFn(val)
	}
	if (props.inputable) {
		nextTick(() => {
			iValue.value = val
		})
	}
})

// 核心值监听
watch(iValue, val => {
	setSelected(val)
	// let finalVal: SelectValueType = val
	// if (props.multiple && props.valueType === 'array' && isString(val)) {
	// 	finalVal = val ? String(val).split(',') : []
	// }
	// emit('change', finalVal, selected.value)
	emit('update:modelValue', val)
	if ($TouchUI) {
		// const detail = {
		// 	name: 'ToSelect',
		// 	value: val,
		// 	desc: validateDesc.value,
		// 	selected: selected.value
		// }
		// $TouchUI.commitTouchReport(detail)
	}
	valueChange(val)
})

// Props监听
watch(
	() => props.modelValue,
	newVal => {
		// if (!isChanging.value) {
		iValue.value = String(newVal || '')
		setValue()
		// }
	},
	{ immediate: true }
)

// 配置相关监听
watch(
	() => props.apiHeaders,
	() => {
		iApiHeaders.value = props.apiHeaders
	},
	{ deep: true }
)

watch(
	() => props.resPath,
	newVal => {
		iResPath.value = newVal
	}
)

watch(
	() => props.successCode,
	newVal => {
		iSuccessCode.value = newVal
	}
)

watch(
	() => props.apiLabel,
	newVal => {
		iApiLabel.value = newVal
	}
)

watch(
	() => props.errorPath,
	newVal => {
		iErrorPath.value = newVal
	}
)

watch(
	() => props.optionWidth,
	newVal => {
		iOptionWidth.value = newVal
	}
)

watch(
	() => props.disabled,
	newVal => {
		disabled.value = newVal
	}
)

/* ================================ 工具方法 ================================ */
const getLabel = val => {
	const obj = options.value.find(item => String(item[iValueText.value]) === String(val))
	if (obj && obj[iLabelText.value]) {
		return obj[iLabelText.value]
	}
	return null
}

// 设置选中项方法（从vue2迁移）
const setSelected = (val: any) => {
	let selectedData = JSON.parse(JSON.stringify(selected.value))

	if (!props.multiple) {
		// 单选模式
		if (options.value.findIndex(option => option[iValueText.value] === val) === -1) {
			selectedData = {
				[iLabelText.value]: val,
				[iValueText.value]: val
			}
		} else {
			selectedData = options.value.find(option => option[iValueText.value] === val)
		}
	} else {
		// 多选模式
		if (val === '') {
			selectedData = []
		} else {
			const arr = Array.isArray(val) ? unique(val) : unique(val.split(props.splitSymbol || ','))
			let selectedArr: any[] = []
			arr.map((item: string) => {
				if (item && item.trim()) {
					if (options.value.findIndex(option => String(option[iValueText.value]) === String(item)) === -1) {
						selectedArr.push({
							[iLabelText.value]: item,
							[iValueText.value]: item,
							hide: !props.inputable // 当输入一个不存在的值的时候，如果可自定义则显示，否则不显示
						})
					} else {
						options.value.map(option => {
							if (String(option[iValueText.value]) === String(item)) {
								selectedArr.push(option)
							}
						})
					}
				}
			})
			selectedData = selectedArr
		}
	}

	if (props.beforeChange) {
		const fn = props.beforeChange(selectedData)
		if (fn && fn.then) {
			fn.then(() => {
				selected.value = selectedData
			}).catch(() => {})
		} else {
			if (fn) {
				selected.value = selectedData
			}
		}
	} else {
		selected.value = selectedData
	}
}

// 数组去重工具函数
const unique = arr => {
	return [...new Set(arr)]
}

const valueChange = val => {
	if (!props.multiple) {
		if (props.inputable) {
			inputValue.value = getLabel(val) || val
		}
		if ((props.filterable || props.remoteMethod) && !props.inputable) {
			filterValue.value = getLabel(val) || ''
		}
		if ((props.filterable || props.remoteMethod) && props.inputable) {
			filterValue.value = getLabel(val) || val
		}
		if (props.setDataFn && !props.inputable) {
			setDataInputValue.value = getLabel(val) || ''
		}
		if (props.setDataFn && props.inputable) {
			setDataInputValue.value = getLabel(val) || val
		}
	}
}

/* ================================ 弹层控制方法 ================================ */
const layerClose = () => {
	if (!props.multiple) {
		if ((props.filterable || props.remoteMethod) && !props.inputable) {
			if (iValue.value) {
				const label = getLabel(iValue.value)
				if (label) {
					filterValue.value = label
				} else {
					filterValue.value = ''
				}
			} else {
				filterValue.value = ''
			}
		}
	} else {
		if (props.inputable) {
			multipleInputValue.value = ''
		}
		if (props.filterable || props.remoteMethod) {
			multipleFilterValue.value = ''
		}
	}
}

const closeLayer = () => {
	optionLayer.value.close()
	layerClose()
}

const toggleLayer = () => {
	openOptionLayer()
}

const layerOpen = () => {
	// 面板打开前重新测量外层缩放比例，避免在 Dialog 等场景中拿到过期数据
	calcScale()
}

/* ============================ 对比方法  ========================================== */
// 记录历史值，以便对比或者取值
const compare = () => {
	valueStore.value.unshift(iValue.value)
}
const setDisabled = (f: boolean) => {
	disabled.value = f
}
// 撤销
const restore = () => {
	iValue.value = valueStore.value[0]
	valueStore.value.splice(0, 1)
}

/* ================================ 组件暴露 ================================ */
defineExpose({
	closeLayer,
	setSelected,
	compare,
	setDisabled,
	restore,
	changed,
	errorTip,
	errorType
})
</script>
